import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import { payPayment } from "../../../redux/common/action";
import { useDispatch } from "react-redux";
import { payBXPAmount } from "../../../redux/ots/action";
import { paySaleAmount } from "../../../redux/sale/action";
import { payRentalAmount } from "../../../redux/rental/action";
import { payAutionAmount, payDepositminimumamount } from "../../../redux/auction/action";

export default function PaymentMethodPageforOTS() {
  const path = "Assets/scss/payment.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();
  const { state } = location;
  const { orderdetails } = state;

  const move = {
    type: orderdetails?.type,
    post_id: orderdetails?.post_id,
    type_of_post: orderdetails?.type_of_post,
    lan: lan,
    movetolive: orderdetails?.move,
  };

  const dopaymentforpackagedservices = () => {
    if(orderdetails?.bxp_request_milestone_id){
      const data = {
        type: "10",
        bxp_request_milestone_id: orderdetails?.bxp_request_milestone_id,
        move: move,
        package_id:orderdetails?.id,
      };
      dispatch(payBXPAmount(data, navigate));
    }
    else{
      const data = {
        type: "9",
        bxp_request_id: orderdetails?.bxp_request_id,
        move: move,
        package_id:orderdetails?.id,
      };
      dispatch(payBXPAmount(data, navigate));
    }
    
  };

  const dopaymentforsale = () => {
    const data = {
      "type": "8",
      "sale_request_id": orderdetails?.sale_id,
    }
    dispatch(paySaleAmount(data, navigate))
  };

  const dopaymentforrental = () => {
    const data = {
      "type": "7",
      "rental_request_id": orderdetails?.rental_id,
      "id": orderdetails?.id,
    }
    dispatch(payRentalAmount(data, navigate))
  };

  const dopaymentforauction = () => {
    const data = {
      "type": "6",
      "bid_id": orderdetails?.bid_id,
      "id": orderdetails?.id,
    }
    dispatch(payAutionAmount(data, navigate))
  };

  const dopaymentfordeposit = () => {
    const data = {
      "type": "5",
      "auction_id":orderdetails?.auction_id,
      "id": orderdetails?.id
    }
    dispatch(payDepositminimumamount(data, navigate))
  };

  const paypayment = () => {
    if (orderdetails?.type_of_post == "packagedservices") {
      dopaymentforpackagedservices();
    } else if (orderdetails?.type_of_post == "sale") {
      dopaymentforsale();
    } else if (orderdetails?.type_of_post == 'rental') {
      dopaymentforrental();
    } else if (orderdetails?.type_of_post == 'auction') {
      dopaymentforauction();
    } else if (orderdetails?.type_of_post == 'deposit') {
      dopaymentfordeposit();
    } else {
      dispatch(payPayment(1, navigate));
    }
  };

  return (
    <div className="payment conatiner-fluid">
      <div className="row payment-row">
        {/* <div className="col-md-8">
          <div className="payment-sec">
            <h6>Select payment methods</h6>
            <div id="accordion" className="accordion">
              <div className="collapse-margin">
                <div className=" " data-toggle="collapse" >
                  <a className="">
                    <label className="checkbox-container">
                      <input name="type" type="radio" value="1" checked={1} />
                      <span className="checkmark">Credit or debit cards</span>
                    </label>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/payment/credit-card.svg`}
                      alt=""
                    />
                  </a>
                </div>
                <div
                  id="collapseOne"
                  className=" collapse collapse-cont show"
                  data-parent="#accordion"
                >
                  <div className="row">
                    <div className="col-md-12 form-group">
                      <label>Card Number</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter card Number"
                      />
                    </div>
                    <div className="col-md-6 form-group">
                      <label>Expiry date</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter  Expiry date"
                      />
                    </div>
                    <div className="col-md-6 form-group">
                      <label>CVV</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter CVV"
                      />
                    </div>
                    <div className="col-md-12 form-group">
                      <label>Name on the card</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter name"
                      />
                    </div>
                    <div className="col-md-12">
                      <button className="btn">Save and make payment</button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="collapse-margin">
                <div
                  className=" collapsed"
                  data-toggle="collapse"

                  data-parent="#accordion"
                >
                  <a className="">
                    <label className="checkbox-container">
                      <input name="type" type="radio" value="1" />
                      <span className="checkmark">Pay using Apple pay</span>
                    </label>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/payment/applepay.svg`}
                      alt=""
                    />
                  </a>
                </div>
                <div
                  id="collapseTwo"
                  className=" collapse collapse-cont"
                  data-parent="#accordion"
                >
                  <p>
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid. 3 wolf moon officia
                    aute, non cupidatat skateboard dolor brunch. Food truck
                    quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor,
                    sunt aliqua put a bird on it squid single-origin coffee
                    nulla assumenda shoreditch et. Nihil anim keffiyeh
                    helvetica, craft beer labore wes anderson cred nesciunt
                    sapiente ea proident. Ad vegan excepteur butcher vice lomo.
                    Leggings occaecat craft beer farm-to-table, raw denim
                    aesthetic synth nesciunt you probably haven't heard of them
                    accusamus labore sustainable VHS.
                  </p>
                </div>
              </div>
              <div className="collapse-margin">
                <div
                  className=" collapsed"
                  data-toggle="collapse"

                  data-parent="#accordion"
                >
                  <a className="">
                    <label className="checkbox-container">
                      <input name="type" type="radio" value="1" />
                      <span className="checkmark">Pay with Paypal</span>
                    </label>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/payment/paypal.svg`}
                      alt=""
                    />
                  </a>
                </div>
                <div
                  id="collapseThree"
                  className=" collapse collapse-cont"
                  data-parent="#accordion"
                >
                  <p>
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid. 3 wolf moon officia
                    aute, non cupidatat skateboard dolor brunch. Food truck
                    quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor,
                    sunt aliqua put a bird on it squid single-origin coffee
                    nulla assumenda shoreditch et. Nihil anim keffiyeh
                    helvetica, craft beer labore wes anderson cred nesciunt
                    sapiente ea proident. Ad vegan excepteur butcher vice lomo.
                    Leggings occaecat craft beer farm-to-table, raw denim
                    aesthetic synth nesciunt you probably haven't heard of them
                    accusamus labore sustainable VHS.
                  </p>
                </div>
              </div>
              <div className="collapse-margin">
                <div
                  className=" collapsed"
                  data-toggle="collapse"

                  data-parent="#accordion"
                >
                  <a className="">
                    <label className="checkbox-container">
                      <input name="type" type="radio" value="1" />
                      <span className="checkmark">Net banking</span>
                    </label>
                    <img src={`${CloudStorage.cloudurl}/Assets/Images/payment/paypal.svg`} alt="" />
                  </a>
                  <div className="form-group">
                    <select className="form-control">
                      <option value="">Select Bank</option>
                      <option value="">Select Bank</option>
                    </select>
                  </div>
                </div>
                <div
                  id="collapseFour"
                  className=" collapse collapse-cont"
                  data-parent="#accordion"
                >
                  <p>
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid. 3 wolf moon officia
                    aute, non cupidatat skateboard dolor brunch. Food truck
                    quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor,
                    sunt aliqua put a bird on it squid single-origin coffee
                    nulla assumenda shoreditch et. Nihil anim keffiyeh
                    helvetica, craft beer labore wes anderson cred nesciunt
                    sapiente ea proident. Ad vegan excepteur butcher vice lomo.
                    Leggings occaecat craft beer farm-to-table, raw denim
                    aesthetic synth nesciunt you probably haven't heard of them
                    accusamus labore sustainable VHS.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="col-md-4 mx-auto">
          <div className="payment-sec">
            <h6>Order summary</h6>
            <div className="summary-flex">
              <p>Deposit amount :</p>
              <p>$ {orderdetails?.post_price}</p>
            </div>
            {/* <div className="summary-flex">
              <p>Platform fee</p>
              <p>$ 0</p>
            </div>
            <div className="summary-flex total">
              <p>Order total</p>
              <p>$ {orderdetails?.post_price}</p>
            </div> */}
            <button
              onClick={() => 
                paypayment()
              }
              className="btn"
            >
              Make payment
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
